import { UPDATE_PASSWORD_PARAMS, UPDATE_PASSWORD_DONE, UPDATE_PASSWORD_ERROR, UPDATE_PASSWORD_RESET } from './actionTypes';
export const updatePassword = (data) => ({
    type: UPDATE_PASSWORD_PARAMS,
    data
});
export const updatePasswordDone = () => ({
    type: UPDATE_PASSWORD_DONE
});
export const updatePasswordError = (data) => ({
    type: UPDATE_PASSWORD_ERROR,
    data
});
export const updatePasswordReset = () => ({
    type: UPDATE_PASSWORD_RESET
});
//# sourceMappingURL=actionCreators.js.map